import { render, staticRenderFns } from "./Ylsfj3.vue?vue&type=template&id=94f46ebc&scoped=true"
import script from "./Ylsfj3.vue?vue&type=script&lang=js"
export * from "./Ylsfj3.vue?vue&type=script&lang=js"
import style0 from "./Ylsfj3.vue?vue&type=style&index=0&id=94f46ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f46ebc",
  null
  
)

export default component.exports